import { env } from '../env';

// Create a custom fetch wrapper with default configuration
const fetchInstance = async (url, options = {}) => {
    const token = window.sessionStorage.getItem('token');
    const subVenueId = window.sessionStorage.getItem('subVenueId');
    
    // Add token and subVenueId to headers
    const headers = {
        'Authorization': `Bearer ${token}`,
        'subVenueId': subVenueId,
    };

    // Add Content-Type for JSON requests if body is present
    if (options.body && typeof options.body === 'string') {
        headers['Content-Type'] = 'application/json';
    }

    // Merge default headers with provided options
    const config = {
        ...options,
        headers: {
            ...headers,
            ...options.headers
        }
    };

    try {
        const response = await fetch(`${env.BASE_URL}${url}`, config);
        
        // Handle common error cases
        if (!response.ok) {
            switch (response.status) {
                case 401:
                    // Handle unauthorized
                    window.sessionStorage.removeItem('token');
                    window.location.href = '/login';
                    break;
                case 403:
                    // Handle forbidden
                    break;
                default:
                    break;
            }
        }
        
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
};

export default fetchInstance; 


// WEBPACK FOOTER //
// ./src/api/fetchConfig.js